export default __webpack_public_path__ + "static/media/re1.67c707f2.png";